$(() =>
{
    window.KondutoService = class KondutoService
    {
        static send(page_category, product)
        {
            var period = 300;     
            var limit = 20 * 1e3;     
            var nTry = 0;     
            var intervalID = setInterval(function() {         
                var clear = limit/period <= ++nTry; 
                        
                if ((typeof(Konduto) !== "undefined") && (typeof(Konduto.sendEvent) !== "undefined")) 
                {             
                    Konduto.sendEvent('page', page_category); 
                    if(product && typeof product == 'object')
                    {
                        Konduto.sendEvent('product', product);
                    }
                    clear = true;         
                }   
                if (clear) 
                { 
                    clearInterval(intervalID); 
                }     
            }, 
            period); 
        }

        static sendUser(user)
        {
            var period = 300;     
            var limit = 20 * 1e3;     
            var nTry = 0;    
            var intervalID = setInterval(function() {        
                var clear = limit/period <= ++nTry;         
                if ((typeof(Konduto) !== "undefined") && (typeof(Konduto.setCustomerID) !== "undefined")&& (typeof(user) !== "undefined")) {  
                    window.Konduto.setCustomerID(user);     
                    clear = true;        
                }         
                if (clear) {
                    clearInterval(intervalID); 
                }     
            }, period);
        }
    }
    
});

window.af_send = function(page_category, product)
{
    let kInterval = setInterval(() => {
        if(typeof KondutoService != 'undefined')
        {
            clearInterval(kInterval); 
            KondutoService.send(page_category, product);
        }
    }, 300);
};

window.af_send_user = function(user)
{
    let kInterval = setInterval(() => {
        if(typeof KondutoService != 'undefined')
        {
            clearInterval(kInterval); 
            KondutoService.sendUser(user);
        }
    }, 300);
};